import { ApolloLink } from "@apollo/client";
import removeDirectives from "../../internal/shared/utils/removeDirectives";
export default function createDirectivesToContextLink() {
    return new ApolloLink(function directivesToContextLink(operation, forward) {
        const { gql, directives } = removeDirectives(operation.query);
        const overridenContext = {};
        if (directives.tag) {
            overridenContext.queryTag = directives.tag;
        }
        if (directives.hash) {
            overridenContext.operationHash = directives.hash;
        }
        operation.query = gql;
        operation.setContext(overridenContext);
        return forward(operation);
    });
}

//# sourceMappingURL=createDirectivesToContextLink.js.map